import styled from 'styled-components';

export const BannerContainer = styled.div`
  background-color: #e97200;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 10px;
  height: 38px;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 100;
`;
